module.exports = __webpack_public_path__ + "static/media/ios-bus.f1624a25.svg";